import React from "react";
import "./style.scss";
import { Col, Row } from "antd";
import { starIcon } from "../../utils/constants";
import ButtonComponent from "../button";
import { HomeMenuContent } from "../../pagesContent/homeMenuContent";
import { useNavigate } from "react-router-dom";

export default function Menu() {
  const navigate = useNavigate();
  const handleOnclick = () => {
    // navigate("/menu");
    window.open("/pdfs/menu.pdf", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="ourMenu">
      <Row align={"stretch"}>
        <Col xs={24} sm={24} lg={12}>
          <div className="menuContentside">
            <div className="menuContent">
              {starIcon}
              <h1>{HomeMenuContent.heading}</h1>
              <p dangerouslySetInnerHTML={{ __html: HomeMenuContent.text }} />
              <ButtonComponent
                text={HomeMenuContent.buttonText}
                type={"link"}
                className={"darkBgCommonBtn"}
                handleOnclick={handleOnclick}
              />
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} lg={12}>
          <div className="menuImage">
            <video width="640" height="480" autoPlay muted playsInline loop>
              <source src={HomeMenuContent.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </Col>
      </Row>
    </div>
  );
}
